class VersalisStickyAtc extends HTMLElement {
  connectedCallback() {
    this.mainButton = document.querySelector('product-form button[name="add"]');
    this.priceContainer = document.querySelector('[id^="price-"]');
    this.triggerButton = this.querySelector("button");
    this.price = this.querySelector("[data-sticky-price]");
    if (!this.mainButton || !this.triggerButton) return;

    this.handleClick = () => {
      if (!this.mainButton.disabled) this.mainButton.click();
    };
    this.triggerButton.addEventListener("click", this.handleClick);

    this.buttonObserver = new MutationObserver(() => this.sync());
    this.buttonObserver.observe(this.mainButton, {
      attributes: true,
      attributeFilter: ["disabled"],
      childList: true,
      subtree: true,
    });

    if (this.priceContainer && this.price) {
      this.priceObserver = new MutationObserver(() => this.sync());
      this.priceObserver.observe(this.priceContainer, { childList: true, subtree: true });
    }

    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => this.classList.toggle("is-visible", !entry.isIntersecting),
      { rootMargin: "0px 0px -20% 0px", threshold: 0 },
    );
    this.visibilityObserver.observe(this.mainButton);
    this.sync();
  }

  disconnectedCallback() {
    this.triggerButton?.removeEventListener("click", this.handleClick);
    this.buttonObserver?.disconnect();
    this.priceObserver?.disconnect();
    this.visibilityObserver?.disconnect();
  }

  sync() {
    if (!this.mainButton || !this.triggerButton) return;
    this.triggerButton.disabled = this.mainButton.disabled;
    const mainLabel = this.mainButton.querySelector("span");
    const stickyLabel = this.triggerButton.querySelector("span");
    if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent;
    if (this.priceContainer && this.price) {
      const mainPrice = this.priceContainer.querySelector(".price");
      const currentPrice = mainPrice?.classList.contains("price--on-sale")
        ? mainPrice.querySelector(".price__sale .price-item--sale")
        : mainPrice?.querySelector(".price__regular .price-item--regular");
      this.price.textContent = currentPrice?.textContent.trim() || "";
    }
  }
}

if (!customElements.get("versalis-sticky-atc")) {
  customElements.define("versalis-sticky-atc", VersalisStickyAtc);
}
